export const GET_DEDUCTIONPLANS = "GET_DEDUCTIONPLANS";
export const GET_DEDUCTIONPLANS_SUCCESS = "GET_DEDUCTIONPLANS_SUCCESS";
export const GET_DEDUCTIONPLANS_FAIL = "GET_DEDUCTIONPLANS_FAIL";

export const GET_DEDUCTION_PLANS_MASTER = "GET_DEDUCTION_PLANS_MASTER";
export const GET_DEDUCTION_PLANS_MASTER_SUCCESS = "GET_DEDUCTION_PLANS_MASTER_SUCCESS";
export const GET_DEDUCTION_PLANS_MASTER_FAIL = "GET_DEDUCTION_PLANS_MASTER_FAIL";

export const GET_DEDUCTIONPLANS_DETAILS = "GET_DEDUCTIONPLANS_DETAILS";
export const GET_DEDUCTIONPLANS_DETAILS_SUCCESS = "GET_DEDUCTIONPLANS_DETAILS_SUCCESS";
export const GET_DEDUCTIONPLANS_DETAILS_FAIL = "GET_DEDUCTIONPLANS_DETAILS_FAIL";

export const DEDUCTIONPLAN_UPDATE = "DEDUCTIONPLAN_UPDATE";
export const DEDUCTIONPLAN_UPDATE_SUCCESS = "DEDUCTIONPLAN_UPDATE_SUCCESS";
export const DEDUCTIONPLAN_UPDATE_FAIL = "DEDUCTIONPLAN_UPDATE_FAIL";

export const DEDUCTIONPLAN_CREATE = "DEDUCTIONPLAN_CREATE";
export const DEDUCTIONPLAN_CREATE_SUCCESS = "DEDUCTIONPLAN_CREATE_SUCCESS";
export const DEDUCTIONPLAN_CREATE_FAIL = "DEDUCTIONPLAN_CREATE_FAIL";

export const DEDUCTIONPLAN_DELETE = "DEDUCTIONPLAN_DELETE";
export const DEDUCTIONPLAN_DELETE_SUCCESS = "DEDUCTIONPLAN_DELETE_SUCCESS";
export const DEDUCTIONPLAN_DELETE_FAIL = "DEDUCTIONPLAN_DELETE_FAIL";

export const GET_CURRENT_PAY_PERIOD = "GET_CURRENT_PAY_PERIOD";
export const GET_CURRENT_PAY_PERIOD_SUCCESS = "GET_CURRENT_PAY_PERIOD_SUCCESS";
export const GET_CURRENT_PAY_PERIOD_FAIL = "GET_CURRENT_PAY_PERIOD_FAIL";

export const GET_FUTURE_PAY_PERIODS = "GET_FUTURE_PAY_PERIODS";
export const GET_FUTURE_PAY_PERIODS_SUCCESS = "GET_FUTURE_PAY_PERIODS_SUCCESS";
export const GET_FUTURE_PAY_PERIODS_FAIL = "GET_FUTURE_PAY_PERIODS_FAIL";

export const GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC = "GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC";
export const GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_SUCCESS = "GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_SUCCESS";
export const GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_FAIL = "GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_FAIL";

export const DEDUCTION_PLAN_CREATE_EMPLOYEE = "DEDUCTION_PLAN_CREATE_EMPLOYEE";
export const DEDUCTION_PLAN_CREATE_EMPLOYEE_SUCCESS = "DEDUCTION_PLAN_CREATE_EMPLOYEE_SUCCESS";
export const DEDUCTION_PLAN_CREATE_EMPLOYEE_FAIL = "DEDUCTION_PLAN_CREATE_EMPLOYEE_FAIL";

export const RESET_VALIDATION = "RESET_VALIDATION";
export const RESET_CREATE_RESULT_DEDUCTION = "RESET_CREATE_RESULT_DEDUCTION";

export const RESET = "RESET";

